(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["video-mask"] && !Shopify.designMode) return;
  try {
    (function () {
  if (!window.matchMedia) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function applyReduced() {
    if (!reduce.matches) return;
    var videos = document.querySelectorAll('.vm__video');
    for (var i = 0; i < videos.length; i++) {
      try {
        videos[i].pause();
        videos[i].removeAttribute('autoplay');
      } catch (e) {}
    }
  }

  applyReduced();
  if (reduce.addEventListener) {
    reduce.addEventListener('change', applyReduced);
  }

  // Pause off-screen videos + holo sheen and release GPU layers.
  // Skipped entirely under reduced-motion (videos are already hidden).
  if (!('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      var en = entries[i];
      var vm = en.target;
      var video = vm.querySelector('.vm__video');
      if (en.isIntersecting) {
        vm.classList.add('vm--near');
        vm.classList.remove('vm--offscreen');
        if (video && video.hasAttribute('autoplay') && !reduce.matches) {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        }
      } else {
        vm.classList.remove('vm--near');
        vm.classList.add('vm--offscreen');
        if (video) { try { video.pause(); } catch (e) {} }
      }
    }
  }, { rootMargin: '150px' });

  function observeAll(root) {
    var nodes = (root || document).querySelectorAll('.vm:not([data-vm-obs])');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].setAttribute('data-vm-obs', '1');
      io.observe(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observeAll(); });
  } else {
    observeAll();
  }

  // Re-scan when a section is (re)loaded in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    observeAll(e.target);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
